<template>
  <b-container fluid>
    <b-row>
      <b-modal
        id="modal-resume"
        centered
        title="You have an Unfinished Test"
        ok
        hide-footer
        hide-header
      >
        <p>You have an Unfinished Test which will resume in {{ countdown }}secs</p>
      </b-modal>

      <b-col>
        <div class="m-lg-3 mb-2">
          <div class="mt-5">
            <b-alert
              dismissible
              :show="discountdetails.discount_season"
              variant="info"
            >
              <p class="discount-text">
                Discount alert! {{ discountdetails.discount_title }}!
              </p>
              <p class="discount-text">
                <strong class="discount-value"
                  >{{ discountdetails.discount_percentage }}%</strong
                >
                off on all upgrades
              </p>
              <b-button class=" p-lg-2" :to="{ name: 'upgrade' }" variant="info"
                >Upgrade NOW</b-button
              >
            </b-alert>
          </div>
        </div>
        
        <b-overlay :show="fetching && Object.keys(this.orgspaceobject)?.length == 0" style="min-height:400px" rounded="sm">
          <div v-if="orgspaceobject?.status == 'success'">
            <div class="text-center" style="color: white; text-align: center">
              <h3>Enter Testspace</h3>
            </div>
  
              <div class="card p-3 m-lg-3 mb-2">
                <div class="header-card">
                  <p class="card-title">Testspace Details</p>
                  <div class="card-icon">
                    <b-icon-dash-lg v-if="showSpaceDetails" @click="showSpaceDetails = false" />
                    <b-icon-plus-lg v-if="!showSpaceDetails" @click="showSpaceDetails = true" />
                  </div>
                </div>
  
                <div v-if="showSpaceDetails" class="body-card">
                  <div class="field-division">
                    <div class="flex-parent">
                      <p class="test-title">{{ usecurrenttestspace.test_title }}</p>
                      <p class="written-class">
                        <span style="font-style: italic; font-size: 14px"
                          >Taken by: {{ formatNumberK(usecurrenttestspace.takers_taken) }}
                        </span>
                        <b-icon-person />
                      </p>
                    </div>
                    <h6 class="flex-parent2" style="font-style: italic">
                      {{ usecurrenttestspace.test_description }}
                    </h6>
  
                    <div
                      v-if="usecurrenttestspace.test_structure == 'Section'"
                      class="flex-parent2"
                    >
                      <div class="">
                        <b-badge variant="info">{{ usecurrenttestspace.test_level }} </b-badge>
                      </div>
                    </div>
  
                    <div
                      v-if="usecurrenttestspace.test_structure == 'Section'"
                      class="flex-parent2"
                    >
                      <div class="">
                        <b-badge variant="info">{{ usecurrenttestspace.test_course }} </b-badge>
                      </div>
                    </div>
  
                    <div class="" v-if="usecurrenttestspace.test_structure == 'Subject'">
                      <div class="">
                        <b-badge
                          variant="success"
                          v-for="subject in usecurrenttestspace.test_subjects"
                          :key="subject"
                          class="p-2 m-2 subtext"
                          >{{ subject }}</b-badge
                        >
                      </div>
                    </div>
  
                    <div class="flex-parent2">
                      <p>
                        <b-badge
                          :disabled="true"
                          :variant="
                            usecurrenttestspace.test_status == 'Closed' ? 'danger' : 'info'
                          "
                          >{{ usecurrenttestspace.test_status }}</b-badge
                        >
                      </p>
                      <p>{{ usecurrenttestspace.reason }}</p>
                    </div>
  
                    <div class="flex-parent2">
                      <p>
                        <span style="color: green"
                          >Open{{
                            usecurrenttestspace.test_state == "expired" ||
                            usecurrenttestspace.test_state == "ongoing"
                              ? "ed"
                              : "s"
                          }}:</span
                        >
                        {{
                          dataFormatter(
                            usecurrenttestspace.test_startdate,
                            usecurrenttestspace.test_starttime
                          )
                        }}
                      </p>
                      <p>
                        <span style="color: red"
                          >Clos{{
                            usecurrenttestspace.test_state == "expired" ? "ed" : "es"
                          }}:</span
                        >
                        {{
                          dataFormatter(
                            usecurrenttestspace.test_enddate,
                            usecurrenttestspace.test_endtime
                          )
                        }}
                      </p>
                    </div>
  
                    <div
                      v-if="
                        usecurrenttestspace.test_state == 'approaching' ||
                        usecurrenttestspace.test_state == 'ongoing'
                      "
                      class="flex-parent2"
                    >
                      <p class="test-state">
                        Test
                        {{
                          usecurrenttestspace.test_state == "approaching" ? "opens" : "closes"
                        }}
                        in
                      </p>
                      <Timer
                        @autosubmit="refetchSpaces()"
                        :timeer="usecurrenttestspace.test_timer"
                        class="timer mr-lg-3 mr-1 pt-1"
                      ></Timer>
                    </div>
  
                    <div class="button-take pr-4">
                      <div class="">
                        <p class="text-powered pt-2">
                          Powered by <span>{{ usecurrenttestspace.organization }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="card p-3 m-lg-3 mb-2">
                <div class="header-card">
                  <p class="card-title">Testhall Details</p>
                  <div class="card-icon">
                    <b-icon-dash-lg v-if="showHallDetails" @click="showHallDetails = false" />
                    <b-icon-plus-lg v-if="!showHallDetails" @click="showHallDetails = true" />
                  </div>
                </div>
  
                <div v-if="showHallDetails" class="body-card">
                  <div class="field-division">
                    <div class="">
                      This test can only be taken
                      <b-badge size="lg" class="p-2 m-2"
                        >{{
                          usecurrenttestspace.test_frequency != 0
                            ? usecurrenttestspace.test_frequency
                            : "multiple"
                        }}
                        time{{
                          usecurrenttestspace.test_frequency > 1 ||
                          usecurrenttestspace.test_frequency == 0
                            ? "s"
                            : ""
                        }}</b-badge
                      >
                    </div>
                    <div v-if="usecurrenttestspace.test_status == 'Opened'" class="">
                      <div>
                        Test is Currently
                        <b-badge
                          class="p-2 m-2"
                          :variant="
                            usecurrenttestspace.take_lock == 'Locked' ? 'danger' : 'success'
                          "
                          >{{ usecurrenttestspace.take_lock }}</b-badge
                        >
                        For you because {{ usecurrenttestspace.lock_reason }}
                      </div>
                    </div>
                    <!-- <p class=""></p> -->
                    <p class="">
                      You have taken this test
                      <b-badge
                        class="p-2 m-2"
                        :variant="
                          usecurrenttestspace.user_frequency ==
                          usecurrenttestspace.test_frequency
                            ? 'danger'
                            : 'success'
                        "
                        >{{ usecurrenttestspace.user_frequency }} time{{
                          usecurrenttestspace.user_frequency > 1 ? "s" : ""
                        }}</b-badge
                      >
                    </p>
                  </div>
                </div>
  
                <div class="footer-edit text-right mt-3">
                  <!-- <b-button class="" type="submit" variant="success">Take <b-icon-pencil-square></b-icon-pencil-square></b-button> -->
                  <b-overlay
                    :show="proceeding"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="w-100"
                  >
                    <b-button
                      type="submit"
                      style="width: 120px"
                      :disabled="
                        usecurrenttestspace.take_lock == 'Locked' ||
                        usecurrenttestspace.test_status == 'Closed'
                      "
                      class="take-button p-2 v-button p-lg-2"
                      variant="success"
                      @click="takeTest()"
                    >
                      Take Test
                    </b-button>
                  </b-overlay>
                </div>
              </div>
          </div>
  
          <div v-else class="mt-5">
            <div class="card p-3 m-lg-3 mb-2">
              <div class="body-card">
                <div class="field-division">
                  <div class="alert msg-div" :class="'alert-' + orgspaceobject?.status">
                    {{ orgspaceobject?.msg }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </b-col>
      
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
import Timer from "@/components/Timer.vue";

export default {
  components: {
    Timer,
  },
  data() {
    return {
      usecurrentorg: [],
      testspacesarray: [],
      usecurrenttestspace: [],
      select: this.getselected(),
      countdown: 5,
      proceeding: false,
      monthArray: [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      showSpaceDetails: true,
      showHallDetails: true,
      spaceInterval: "",
      fetching : false,
      orgspaceobject: {}
    };
  },

  mounted() {
    // let useremail = store.state.loginmaster.details.email
    // console.log(useremail)

    // this.emptyTestspace();

    this.refetchSpaces()

    if (!this.loggedin) {
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
    }

    this.spaceInterval = setInterval(() => {
      this.refetchSpaces();
    }, 30000);

    store.dispatch("exam/retrieveCategories");
    store.dispatch("exam/retrieveInstitutions");
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.spaceInterval);
    next();
  },

  // beforeRouteEnter(to, from, next) {
  //   let spacecode = to.params.trackcode;
  //   let useremail = store.state.loginmaster.details.email;

  //   let codeObj = {
  //     spacecode: spacecode,
  //     useremail: useremail,
  //   };

  //   store.dispatch("dashboard/fetchTestspace", { codeObj }).then(() => {
  //     next();
  //   });
  // },
  watch: {
    countdown(oldval, newval) {
      if (oldval > newval) {
        this.reduceCountdown();
      }
    },
    // orgspaceobject: {
    //   handler(oldval, newval) {
    //     let currenttestspace = newval?.spacedata; //this.testspacesarray.filter(x => x.trackid == testspaceid)
    //     this.usecurrenttestspace = Object.keys(this.orgspaceobject).length > 0 ? currenttestspace[0] : []
    //   },
    //   deep: true,
    // },
  },

  methods: {
    ...mapActions("admin", ["fetchOrganization"]),
    ...mapActions("exam", ["setSelect"]),
    ...mapActions("dashboard", ["fetchTestspace", "emptyTestspace"]),

    dataFormatter(date, time) {
      let sdate = new Date(`${date} ${time}`);
      let sdatestring =
        this.monthArray[sdate.getMonth()] +
        " " +
        sdate.getDate() +
        ", " +
        sdate.getFullYear();

      let stimestring =
        (sdate.getHours() <= 12 ? sdate.getHours() : sdate.getHours() - 12) +
        ":" +
        (sdate.getMinutes() < 10 ? `0${sdate.getMinutes()}` : sdate.getMinutes()) +
        (sdate.getHours() < 12 ? "am" : "pm");

      return sdatestring + " at " + stimestring;
    },
    async refetchSpaces() {
      this.fetching = true;
      
      try {

        let spacecode = this.$route.params.trackcode;
        let useremail = store.state.loginmaster.details.email;

        let codeObj = {
          spacecode: spacecode,
          useremail: useremail,
        };

        const response = await this.fetchTestspace({ codeObj });
        this.orgspaceobject = response?.data

        let currenttestspace = this.orgspaceobject?.spacedata; //this.testspacesarray.filter(x => x.trackid == testspaceid)
        this.usecurrenttestspace = Object.keys(this.orgspaceobject).length > 0 ? currenttestspace[0] : []

        this.fetching = false;
      } catch (err) {
        this.fetching = false;
      }
    },
    // async  {
      
      
    //   this.fetching = false
    // },
    getselected() {
      return {
        organization: "",
        organization_id: "",
        category: null,
        institution: null,
        institution_id: null,
        level: null,
        course: null,
        scholarship: null,
        subjects: [],
        topics: [],
        reducer: 25,
        questionspertopic: 5,
        minutesperquestion: 1,
        mode: "Prototype",
        testspaceid: "",
        testsource: "thirdparty",
        candidate: this.$store.state.loginmaster.details,
      };
    },
    takeTest() {
      this.proceeding = true;

      this.select.organization = this.usecurrenttestspace.organization;
      this.select.organization_id = this.usecurrenttestspace.organization_id;
      this.select.category = this.usecurrenttestspace.test_category;
      this.select.institution = this.usecurrenttestspace.test_institution;
      this.select.institution_id = this.usecurrenttestspace.test_institution_id;
      this.select.level = this.usecurrenttestspace.test_level;
      this.select.course = this.usecurrenttestspace.test_course;
      this.select.subjects = this.usecurrenttestspace.test_subjects;
      this.select.mode = this.usecurrenttestspace.test_mode;
      this.select.testspaceid = this.usecurrenttestspace.trackid;
      this.select.candidate = this.details;

      // console.log(this.select)
      return this.setSelect(this.select).then(() => {
        this.proceeding = false;

        // if (this.ongoing) {
        //   // this.countdown = this.countdown - 1;
        //   this.$bvModal.show("modal-resume");
        //   this.reduceCountdown();
        // } else if (this.start_config.start == "Yes") {
        this.$router.push({
          name: "confirm",
        });
        // }
      });
    },
    movedown() {
      let categoryName = JSON.parse(this.start_config.category).name;
      // console.log( JSON.parse(this.start_config.category).name)
      this.$router.push({
        name: "testhall",
        params: {
          trackid: this.start_config.track_id,
          category: categoryName,
          institution: this.start_config.institution_shortname,
        },
      });
    },
    reduceCountdown() {
      this.countdown = this.countdown - 1;
      setTimeout(() => {
        // this.countdown = this.countdown - 1;
        this.reduceCountdown();
        if (this.countdown == 0) {
          this.movedown();
        }
      }, 1000);
    },
  },

  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      ongoing: (state) => state.ongoing,
      start_config: (state) => state.exam.start_config,
      loggedin: (state) => state.loginmaster.loggedIn,
      discountdetails: state => state.loginmaster.details.discount_details
    }),
  },
};
</script>

<style>
.card {
  /* min-height: 70vh; */
  background-color: rgb(242, 242, 242);
  border-radius: 20px 20px;
}
.card-title {
  font-size: 1.2rem;
  font-weight: bold;
}
.card-icon {
  cursor: pointer;
}
.field-division {
  margin-top: 7px;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  /* height: 3rem; */
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.footer-edit {
  width: 100%;
}
.test-state {
  font-size: 18px;
  margin-top: 13px;
}
.msg-div {
  font-size: 1.5rem;
}
.test-title {
  font-weight: bold;
  padding-left: 10px;
}

.flex-parent {
  display: flex;
  flex-flow: row wrap;
  gap: 10px;
  justify-content: space-between;
  /* height: 35px; */
}

.flex-parent2 {
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 0px 10px;
  gap: 10px;
  justify-content: flex-start;
  /* height: 35px; */
}

.header-card {
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 0px 10px;
  gap: 10px;
  justify-content: space-between;
}

.take-button {
  width: 40%;
}

.button-take {
  display: flex;
  flex-flow: row;
  padding: 0px 10px 0px 10px;
  margin-top: 15px;
  gap: 10px;
  justify-content: center;
}

.text-powered {
  font-size: 17px;
  font-style: italic;
}

@media screen and (max-width: 999px) {
  .v-button {
    width: inherit;
    /* height: 2.5rem; */
    font-size: 0.8rem;
  }
  .s-header {
    font-size: 16px;
  }
  .take-button {
    width: 50%;
  }
  .test-state {
    font-size: 18px;
    margin-top: 8px;
  }
}
</style>
